import React, { useMemo, useCallback, FC, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import Model, { helper } from '@tripian/model';
import { GoogleMaps } from '@tripian/react';
import {
  handleMapClick,
  /* handleClickMarkerStep, */
  /* handleFocusChangeAlternative, */
  changeLegs,
  changedCenter,
  changedZoom,
  changedBoundry,
} from '../../../../redux/action/gmaps';
// import { changeFocusInfoVisible } from '../../../../redux/action/layout';

// import GoogleMaps from '../../../../components/GoogleMaps/GoogleMaps';
import './Gmap.scss';

import useTrip from '../../../../hooks/useTrip';
import usePlan from '../../../../hooks/usePlan';
import useAlternative from '../../../../hooks/useAlternative';
import IStepAlternatives from '../../../../models/IStepAlternatives';
import useFocus from '../../../../hooks/useFocus';

const getAccommendationStep = (accommendation: Model.Accommodation): Model.Step => {
  const accommendationPoi: Model.Poi = {
    id: 0,
    name: accommendation.name || 'AccommendationState Name',
    description: accommendation.address || 'AccommendationState Address',
    marker_coordinate: accommendation.coordinate || { lat: 0, lng: 0 },
    //
    city_id: 0,
    image: { url: '', image_owner: { title: '', url: '', avatar: '' }, width: null, height: null },
    gallery: [],
    price: 5,
    rating: 5,
    rating_count: 0,
    web: null,
    phone: null,
    address: null,
    icon: 'Homebase',
    coordinate: accommendation.coordinate || { lat: 0, lng: 0 },
    booking: [],
    category: [],
    tags: [],
    must_tries: [],
    cuisines: null,
    attention: null,
    hours: null,
    closed: [],
    distance: null,
    status: true,
    safety: null,
  };

  const accommendationStep: Model.Step = {
    id: 0,
    poi: accommendationPoi,
    alternatives: [],
    order: -1,
    score: null,
    hours: { from: '', to: '' },
  };

  return accommendationStep;
};

interface IGMap {
  planDayIndex: number;
  alternativesStepId?: number;
  showAllalternatives: boolean;
  searchThisAreaPois: Model.Poi[];
}

const GMap: FC<IGMap> = ({ planDayIndex, alternativesStepId, showAllalternatives, searchThisAreaPois }) => {
  const { tripReference } = useTrip();
  const { planDay } = usePlan();
  const { alternatives } = useAlternative();
  const { focus, focusStep, focusPoi, focusLost } = useFocus();

  const plan = useMemo(() => planDay(planDayIndex), [planDay, planDayIndex]);

  const dispatch = useDispatch();

  const cityBounds = useMemo(() => {
    // console.log('cityBounds memo', tripReference?.city);
    // {south: -50, west: -100, north:50, east: 100}
    const cityBoundsNumbers = tripReference?.city.boundary || [-100, -50, 50, 100];
    const result = {
      north: cityBoundsNumbers[1],
      south: cityBoundsNumbers[0],
      west: cityBoundsNumbers[2],
      east: cityBoundsNumbers[3],
    };

    if (tripReference) {
      setTimeout(() => {
        if (window.twindow.map && !window.twindow.planBounds) {
          window.twindow.map.fitBounds(result);
        }
      }, 100);
    }

    return result;
  }, [tripReference]);

  const stepsMemo = useMemo(() => {
    let steps: Model.Step[] = [];

    if (plan && plan.generated_status !== 0) {
      steps = plan.steps;
    } else {
      return [];
    }

    // console.log('GMap.stepsMemo useMemo called', steps, accommodation);

    /**
     * TODO
     * @PenguenUmut
     *
     * accommendation:{} gelme ihtimaline karşı sigorta.
     * */
    if (
      tripReference &&
      tripReference.trip_profile.accommodation &&
      tripReference.trip_profile.accommodation.coordinate &&
      !(tripReference.trip_profile.accommodation.coordinate.lat === 0 && tripReference.trip_profile.accommodation.coordinate.lng === 0)
    ) {
      const accommendationStep = getAccommendationStep(tripReference.trip_profile.accommodation);
      const stepsWithAccommendation = [accommendationStep, ...steps];

      if (stepsWithAccommendation.length > 0) stepsWithAccommendation.push(accommendationStep);
      return stepsWithAccommendation;
    }

    return steps;
  }, [tripReference, plan]);

  const alternativesMemo = useMemo(() => {
    // console.log('GMap.alternativesMemo useMemo called', steps, showAllalternatives, alternatives, alternativesStepId);

    // tripData undefined
    if (plan && alternatives) {
      // Map button (show all alternatives)
      if (showAllalternatives) return helper.removeDuplicateValuesById<Model.Poi>(alternatives.reduce<Model.Poi[]>((preValues: Model.Poi[], currentValues: IStepAlternatives) => preValues.concat(currentValues.pois), []));

      // Clicked show alternatives on StepCard
      if (alternativesStepId) {
        const stepAlternatives = alternatives.find((alternative: IStepAlternatives) => alternative.stepId === alternativesStepId);
        if (stepAlternatives) return stepAlternatives.pois;
      }
    }

    return [];
  }, [alternatives, alternativesStepId, plan, showAllalternatives]);

  useEffect(() => {
    if (stepsMemo.length <= 1) {
      dispatch(changeLegs([]));
    }
  }, [dispatch, stepsMemo.length]);

  const setLegsCallback = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (legs: any[]) => {
      dispatch(changeLegs(legs));
    },
    [dispatch],
  );

  const focusMarkerStepOrPoiId = useMemo(() => {
    if (focus.step) {
      return focus.step.id;
    }

    return focus.alternative?.poi.id || focus.poi?.id;
  }, [focus]);

  const gMap = useMemo(
    () => (
      <GoogleMaps
        /* gmapZoom={gmapZoom} gmapCenter={gmapCenter} */

        onZoomChanged={() => {
          dispatch(changedZoom(window.twindow.map?.getZoom()));
          dispatch(changedBoundry(window.twindow.map?.getBounds()));
        }}
        onCenterChanged={() => {
          dispatch(changedCenter(window.twindow.map?.getCenter()));
          dispatch(changedBoundry(window.twindow.map?.getBounds()));
        }}
        // focus data props
        steps={stepsMemo}
        alternativePois={alternativesMemo}
        searchPoi={focus.poi}
        searchAreaPois={searchThisAreaPois}
        cityBounds={cityBounds}
        // direction result legs
        setLegs={setLegsCallback}
        // poi info poi id by focus for marker animation
        focusMarkerStepOrPoiId={focusMarkerStepOrPoiId}
        // lost focus for map empty click
        mapClicked={(coordinate: Model.Coordinate) => {
          focusLost();
          dispatch(handleMapClick(coordinate));
        }}
        // step poi marker click
        markerStepClicked={focusStep}
        // alternative poi marker click
        markerAlternativeClicked={focusPoi}
        markerSearchThisAreaClicked={focusPoi}
      />
    ),
    [alternativesMemo, cityBounds, dispatch, focus.poi, focusLost, focusMarkerStepOrPoiId, focusPoi, focusStep, searchThisAreaPois, setLegsCallback, stepsMemo],
  );

  return gMap;
};

export default GMap;
